import { QuestionBase } from './question-base';

export class RangeQuestion extends QuestionBase<string> {
  controlType = 'range';
  type = 'range';
  color?: string;
  startIcon?: string;
  endIcon?: string;
  min?: number;
  max?: number;
  step?: number;
  startLabel?: string;
  endLabel?: string;
  dualKnobs?: boolean;

  constructor(options: any = {}) {
    super(options);
    this.type = options['type'] || '';
    this.color = options['color'] || 'primary';
    this.startIcon = options['startIcon'] || '';
    this.endIcon = options['endIcon'] || '';
    this.min = options['min'] || 0;
    this.max = options['max'] || 0;
    this.step = options['step'] || 1;
    this.startLabel = options['startLabel'] || void 0;
    this.endLabel = options['endLabel'] || void 0;
    this.dualKnobs = options['dualKnobs'] || false;
  }
}
